import {
	Button,
	Divider,
	em,
	Flex,
	FloatingIndicator,
	Group,
	LoadingOverlay,
	Pagination,
	SimpleGrid,
	Tabs,
	Text,
	TextInput,
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconClipboardList, IconPlus, IconSearch } from '@tabler/icons-react'
import { Fragment, useEffect, useState } from 'react'
import OrderCard from '../../../components/OrderCard.tsx'
import Colors from '../../../constants/colors.ts'
import { getAllBusinessOrdersAction } from '../../../store/oders/ordersActions.ts'
import { getOrdersByBusinessIdAction } from '../../../store/seller/sellerActions.ts'
import { useAppDispatch, useAppSelector } from '../../../store/store.ts'
import { getUser } from '../../../utils/storage.ts'
import classes from './Order.module.css'
import OrdersTable from './OrdersTable.tsx'

const Orders = () => {
	const isMobile = useMediaQuery(`(max-width: ${em(768)})`)
	const dispatch = useAppDispatch()
	const user = getUser()
	const { ordersByBusiness, loader } = useAppSelector((state) => state.seller)

	const handlePage = (page: number) => {
		dispatch(getAllBusinessOrdersAction(page))
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	// const [currentOrders, setCurrentOrders] = useState<Order[]>([])
	// const [pastOrders, setPastOrders] = useState<Order[]>([])
	const [rootRef, setRootRef] = useState<HTMLDivElement | null>(null)
	const [value, setValue] = useState<string | null>('1')
	const [status, setStatus] = useState<string | null>('')
	const [controlsRefs, setControlsRefs] = useState<
		Record<string, HTMLButtonElement | null>
	>({})
	const setControlRef = (val: string) => (node: HTMLButtonElement) => {
		controlsRefs[val] = node
		setControlsRefs(controlsRefs)
	}

	useEffect(() => {
		if (!user?.businessID) return
		dispatch(
			getOrdersByBusinessIdAction({
				businessId: user?.businessID?._id,
				status: status || '',
			})
		)
	}, [dispatch, status, user?.businessID])

	return (
		<Flex direction='column'>
			<LoadingOverlay visible={loader.gettingOrdersByBusiness} />
			<Flex w='100%' justify='space-between' align='center'>
				<Text fw={700} size='24px' mb='sm' p={'md'}>
					My Orders
				</Text>
			</Flex>
			<Divider />
			<Tabs variant='none' value={value} onChange={setValue} mt='md'>
				<Flex align={'center'} w={'100%'} justify='space-between'>
					<Tabs.List ref={setRootRef} className={classes.list} mx={'lg'}>
						<Tabs.Tab
							value='1'
							ref={setControlRef('1')}
							className={classes.tab}
							onClick={() => {
								setStatus('')
							}}
						>
							All
						</Tabs.Tab>
						<Tabs.Tab
							value='2'
							ref={setControlRef('2')}
							className={classes.tab}
							onClick={() => {
								setStatus('assigned')
							}}
						>
							Assigned
						</Tabs.Tab>
						<Tabs.Tab
							value='3'
							ref={setControlRef('3')}
							className={classes.tab}
							onClick={() => {
								setStatus('processed')
							}}
						>
							Processed
						</Tabs.Tab>
						<Tabs.Tab
							value='4'
							ref={setControlRef('4')}
							className={classes.tab}
							onClick={() => {
								setStatus('delivered')
							}}
						>
							Delivered
						</Tabs.Tab>
						<Tabs.Tab
							value='5'
							ref={setControlRef('5')}
							className={classes.tab}
							onClick={() => {
								setStatus('confirmed')
							}}
						>
							Confirmed
						</Tabs.Tab>
						<Tabs.Tab
							value='6'
							ref={setControlRef('6')}
							className={classes.tab}
							onClick={() => {
								setStatus('cancelled')
							}}
						>
							Cancelled
						</Tabs.Tab>

						<FloatingIndicator
							target={value ? controlsRefs[value] : null}
							parent={rootRef}
							className={classes.indicator}
						/>
					</Tabs.List>
					<Group>
						<TextInput
							placeholder='Search'
							leftSection={<IconSearch />}
							size='sm'
							w={isMobile ? '100%' : '400px'}
							radius={'md'}
						/>
						<Button size='md' color={Colors.primaryColor}>
							<IconPlus /> Add Product
						</Button>
					</Group>
				</Flex>
				<Tabs.Panel value={value || ''}>
					{ordersByBusiness?.orders?.length <= 0 ? (
						<Flex direction='column' justify='center' align='center' h='75vh'>
							<IconClipboardList
								color='#62BE12'
								stroke={0.7}
								size={isMobile ? 150 : 250}
							/>
							<Text>No Orders found</Text>
						</Flex>
					) : (
						<>
							{isMobile ? (
								<SimpleGrid
									cols={{ base: 1, sm: 2, lg: 2 }}
									spacing={{ base: 10, sm: 'xl' }}
									verticalSpacing={{ base: 'md', sm: 'xl' }}
									mt='sm'
								>
									{ordersByBusiness?.orders?.map((order, i) => {
										return (
											<Fragment key={i}>
												<OrderCard
													order={order}
													isBuyer={false}
													loading={loader.gettingOrdersByBusiness}
												/>
											</Fragment>
										)
									})}
								</SimpleGrid>
							) : (
								<OrdersTable
									orders={ordersByBusiness?.orders}
									isBuyer={false}
									loading={loader.gettingOrdersByBusiness}
								/>
							)}
						</>
					)}
				</Tabs.Panel>
			</Tabs>
			<Flex justify='end' mt='md' mb='md'>
				{ordersByBusiness?.orders?.length > 0 && (
					<Pagination
						color='#62BE12'
						m='sm'
						total={ordersByBusiness?.totalPages}
						onChange={handlePage}
					/>
				)}
			</Flex>
		</Flex>
	)
}

export default Orders
